import { createContext } from 'react';

export interface ProviderNavigationState {
  sections: string[];
  activeSection: string | null;
  branding: {
    name: string | null;
    logoUrl: string | null;
    slug: string | null;
  };
}

export interface ProviderNavigationContextType {
  providerNavigation: ProviderNavigationState;
  setProviderNavigation: (navigation: ProviderNavigationState) => void;
}

export const ProviderNavigationContext = createContext<ProviderNavigationContextType | null>(null);
